import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap } from "rxjs";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { IExpenseAutocompleteOutput } from "./expense-autocomplete.interface";
import { IExpense } from "../../../admin/expenses-page/expenses/expenses.interface";
import { MyErrorStateMatcher } from "../../util/error-state-matcher";
import { AuthService } from "../../services/auth.service";
import { ExpensesService } from "../../../admin/expenses-page/expenses/expenses.service";
import { ExpensesModalComponent } from "../../../admin/expenses-page/expenses/expenses-modal/expenses-modal.component";

let self: any;

@Component({
  selector: 'app-expense-autocomplete',
  templateUrl: './expense-autocomplete.component.html',
  styleUrls: ['./expense-autocomplete.component.css']
})
export class ExpenseAutocompleteComponent implements OnInit {
  @Input('text') text: string = '';
  @Input('readOnly') readOnly: boolean = false;
  @Output('textChange') textChange = new EventEmitter<IExpenseAutocompleteOutput>();
  @Output('selected') selected = new EventEmitter<IExpenseAutocompleteOutput>();

  item: string = '';
  myControl = new FormControl(''/*, [Validators.maxLength(100)]*/);
  $expenses: Observable<any> = of();
  selectedExpense!: IExpense;
  customErrorStateMatcher = new MyErrorStateMatcher();

  constructor(
    private _AuthService: AuthService,
    private _ExpensesService: ExpensesService,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
  ) {
    self = this;
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  initializeComponent() {
    this.myControl.setValue(this.text);
    // console.log('ProductAutocompleteComponent', 'initializeComponent', this.text);
    // this.selectedProduct = this.item.product;
    this.$expenses = this.myControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(val => {
          // this.changed.emit({ text: val, product: this.selectedProduct });
          return this.filterExpenses(val || '');
        })
      );
  }

  filterExpenses(item: string | IExpense): Observable<any[]> {
    let filter: any = {
      filters: {},
      sort: 'name',
      company: this._AuthService.companyId()
    };
    if (item) filter.filters.name = item;
    return this._ExpensesService.getExpenses(filter);
  }

  expenseSelected(item: IExpense) {
    if (item !== null) {
      this.selectedExpense = item;
      this.myControl.setValue(item.name || null);
      this.selected.emit({
        text: this.myControl.value || '',
        expense: item
      });
    }
  }

  onInput() {
    this.textChange.emit({
      text: this.myControl.value || '',
      expense: this.selectedExpense || undefined
    });
  }

  openNewExpenseModal() {
    this.openExpenseModal({});
  }

  openExpenseModal(expense: IExpense, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExpensesModalComponent, config);
    self.dialogRef.componentInstance.expense = expense;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: IExpense) => {
      self.dialogRef = null;
      if (result) this.expenseSelected(result);
    });
  }
}